import { Formik } from 'formik'
import React from 'react'
import { staffingAgencyPocsDocument, useMutateCreateStaffingAgencyPoc } from 'src/queries'
import Form from './Form'
import validationSchema from '../helpers/formValidation'
import { useInvalidateQueryByDocument } from 'src/hooks/useGraphQL'
import useLookups from '../helpers/useLookups'
import { emptyStringToNull } from 'src/helpers/formHelpers'

interface FormContextProps {
  toggle: () => void
  staffingAgency: string
}

const FormContext: React.FC<FormContextProps> = (props) => {
  const { toggle, staffingAgency } = props
  const create = useMutateCreateStaffingAgencyPoc()
  const lookups = useLookups()
  const invalidatePOCs = useInvalidateQueryByDocument(staffingAgencyPocsDocument)
  const handleSuccess = (): void => {
    void invalidatePOCs({ filter: { staffingAgency } })
    toggle()
  }
  return (
    <Formik
      initialValues={{
        name: '',
        title: '',
        email: '',
        phone: '',
        type: '',
        timezone: '',
        address: {
          street: '',
          city: '',
          state: '',
          zip: ''
        }
      }}
      validationSchema={validationSchema}
      onSubmit={async (data) => {
        const record = {
          ...data,
          staffingAgency
        }
        emptyStringToNull(record, 'type')
        emptyStringToNull(record, 'timezone')

        create.mutate({ record }, { onSuccess: handleSuccess })
      }}
    >
      {(props) => (
        <Form toggle={toggle} isLoading={create.isLoading} hasError={create.isError} lookups={lookups} />
      )}
    </Formik>
  )
}

export default FormContext
